










































import {Vue, Component} from 'vue-property-decorator';
import RadioElement from '@/components/common/RadioElement.vue';
import {addClass, removeClass} from '@/utils/classUtils';
import {popupResize} from '@/utils/ncp';

import {GetMemberGradesRequest, PutMembersGradeRequest} from 'supporter';

@Component({
  components: {RadioElement}
})
export default class GradeUpdate extends Vue {
  // 변경 대상회원
  private memberName: string = '';
  // 회원등급 선택
  private gradeNo: number = -1;
  private grades = {
    name: 'grades',
    data: [] as any
  };
  // 변경 사유
  private reason: string = '';

  private memberNos: number[] = [];

  private async apply() {
    if (this.gradeNo === -1) {
      alert(this.$t('MEMBER_POPUP_ALERT_GRADE_NO_NULL'));
      (this.$refs.gradeNo as any).focus();
      return;
    }
    if (this.reason.trim() === '') {
      alert(this.$t('MEMBER_POPUP_ALERT_REASON_NULL'));
      (this.$refs.reason as any).focus();
      return;
    }
    let request: PutMembersGradeRequest = {
      data: {
        reason: this.reason,
        gradeNo: this.gradeNo,
        memberNos: this.memberNos
      }
    };
    let {data} = await this.$api.putMembersGrade(request);

    let alertMsg = data.successCount > 0 ? this.$t('MEMBER_POPUP_GRADE_SUCCESS_MSG', [data.successCount]) : '';
    if (data.failCount > 0) {
      alertMsg += this.$t('MEMBER_POPUP_FAIL_MSG', [data.failCount, data.failures[0].reason]) as string;
    }
    alert(alertMsg);
    this.cancel();
  }
  private cancel() {
    if (this.$route.query && this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}();`);
    }
    window.close();
  }
  private async mounted() {
    addClass(document.body, 'popup_small');
    if (this.$route.query) {
      // 변경 대상회원
      this.memberName = sessionStorage.getItem('memberName') as string;

      // 회원등급 선택
      this.gradeNo = Number(sessionStorage.getItem('memberGradeNo'));
      let request: GetMemberGradesRequest = {
        params: {
          mallNo: Number(this.$route.query.mallNo)
        }
      };

      let {data} = await this.$api.getMemberGrades(request);
      let tempGrades = data.sort((itemA: any, itemB: any) => {
        return itemA.order > itemB.order ? 1 : -1;
      });
      tempGrades.forEach((grade: any) => {
        if (grade.used) {
          let gradesItem = {
            id: `grades_${grade.no}`,
            value: grade.no,
            dispaly: grade.name
          };
          this.grades.data.push(gradesItem);
        }
      });
      this.memberNos = (this.$route.query.memberNumbers as string).split(',').map((item: string) => Number(item));
    }
    this.$nextTick(() => {
      popupResize(undefined, undefined);
    });
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_small');
  }
}
